var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-row',{staticClass:"justify-center"},[_c('v-progress-circular',{staticClass:"align-center",attrs:{"indeterminate":"true"}})],1):_c('supplier-form',{attrs:{"supplier":_vm.supplier,"is-edit":true}})}
var staticRenderFns = []

export { render, staticRenderFns }